import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterPre',
})
export class FilterPipePre implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items || !searchText) {
            return items;
        }

        searchText = searchText.toLowerCase();

        return items.filter((item) => {
            return (
                Object.keys(item).some((key) =>
                    item[key].toString().toLowerCase().includes(searchText)
                ) ||
                (item.empaqueUnidadMedida &&
                    item.empaqueUnidadMedida.empaque.nombre
                        .toLowerCase()
                        .includes(searchText)) ||
                (item.empaqueUnidadMedida &&
                    item.empaqueUnidadMedida.unidadMedida.nombre
                        .toLowerCase()
                        .includes(searchText)) ||
                (item.empaqueUnidadMedida &&
                    item.estado.toLowerCase().includes(searchText))
            );
        });
    }
}
